import React from 'react';
import {useTable} from 'react-table';
import Cell from './Cell';
import {useParams} from 'react-router-dom';
import {
  useKeyPersonsByAccountPoolQuery,
  KeyPerson,
  AccountKeyPerson,
} from 'api';
import moment from 'moment';

export default () => {
  const {accountId} = useParams<{
    accountId: string;
  }>();
  const {data: {keyPersonsByAccountPool = []} = {}} =
    useKeyPersonsByAccountPoolQuery({
      variables: {
        uuid: accountId,
      },
    });

  const columns: any = React.useMemo(
    () => [
      {
        id: 'name',
        Header: '名前/部署・役職',
        style: {
          minWidth: '360px',
        },
        Cell: (row: any) => Cell.Name(row),
      },
      {
        id: 'social',
        Header: 'SNSリンク',
        Cell: (row: any) => Cell.Sns(row),
        style: {
          width: '200px',
        },
      },
      {
        id: 'media',
        Header: '掲載メディア',
        Cell: (row: any) => {
          const keyPerson: KeyPerson = row.row.original;
          return (
            <>
              {keyPerson.articles?.map((article) => (
                <div key={article.id}>
                  <a
                    href={`${article.url}`}
                    className="truncate"
                    target="_blank">
                    {article.caseStudy.siteName}
                  </a>
                </div>
              ))}
            </>
          );
        },
        style: {
          width: '100px',
        },
      },
      {
        id: 'mediaDate',
        Header: '掲載日',
        Cell: (row: any) => {
          const keyPerson: KeyPerson = row.row.original;
          return (
            <>
              {keyPerson.articles?.map((article) => (
                <div key={article.id}>{article.publishedDate}</div>
              ))}
            </>
          );
        },
        style: {
          width: '100px',
        },
      },
      {
        id: 'note',
        Header: '備考',
        Cell: (row: any) => {
          const accountKeyPerson: AccountKeyPerson =
            row.row.original.accountKeyPerson;
          return (
            <div className="whitespace-pre-wrap">{accountKeyPerson?.note}</div>
          );
        },
        style: {
          width: '280px',
        },
      },
      {
        id: 'tel',
        Header: '電話番号',
        Cell: (row: any) => {
          const accountKeyPerson: AccountKeyPerson =
            row.row.original.accountKeyPerson;
          return <div>{accountKeyPerson?.telephoneNumber}</div>;
        },
        style: {
          width: '100px',
        },
      },
      {
        id: 'updateDate',
        Header: '更新日',
        Cell: (row: any) => {
          const keyPerson: KeyPerson = row.row.original;
          return <div>{moment(keyPerson?.updatedAt).format('YYYY/MM/DD')}</div>;
        },
        style: {
          width: '100px',
        },
      },
      {
        id: 'menu',
        Header: '',
        Cell: Cell.Menu,
        style: {
          width: '80px',
        },
      },
    ],
    [],
  );

  const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow} =
    useTable<any>({columns, data: keyPersonsByAccountPool || []});

  return (
    <div className="flex flex-col items-center">
      <table
        {...getTableProps()}
        cellSpacing="0"
        cellPadding="0"
        className="w-full table-fixed border-separate border-spacing-0 border-l border-r border-c-border">
        <thead className="text-c-light text-xs">
          {headerGroups.map((headerGroup, i) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={i}>
              {headerGroup.headers.map((column, j) => {
                return (
                  <th
                    className="py-2 px-4 text-xs text-c-light border-y text-left border-c-border bg-white leading-tight h-9"
                    {...column.getHeaderProps([
                      {
                        // @ts-ignore
                        style: column.style,
                      },
                    ])}
                    key={j}>
                    {column.render('Header')}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} className="text-sm">
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, j) => {
                  return (
                    <td
                      className="min-w-[50px] h-20 py-2 px-4 border-b border-c-border truncate bg-white"
                      {...cell.getCellProps()}
                      key={j}>
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
